export const AXIOS = 'axios';

// modal types
export const MODAL_CENTER = 'MODAL_CENTER';
export const MODAL_SIDE = 'MODAL_SIDE';

//modal events
export const MODAL_CLOSE = 'MODAL_CLOSE';
export const MODAL_CONFIRM = 'MODAL_CONFIRM';
